<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="bg-gray-50 rounded-lg p-4 flex flex-col items-start justify-center shadow-sm">
        <b-skeleton animation="wave" width="50%" height="14px" class="mb-1"></b-skeleton>
        <b-skeleton animation="wave" width="120px" height="36px" class="mt-1"></b-skeleton>
      </div>
    </template>
    <div class="bg-gray-50 rounded-lg p-4 flex flex-col items-start justify-center shadow-sm">
      <p class="text-gray-600 text-sm font-medium mb-1">Tiempo de Estudio</p>
      <p class="text-4xl font-bold text-gray-800">{{ studyTimeHours }}h {{ studyTimeMinutes }}m</p>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getStudyTimeKpi } from '@/services/stats.service';

export default {
  name: 'StudyTime',

  data() {
    return {
      studyTime: {
        totalMinutes: 0,
      },
      loading: true,
    };
  },

  props: {
    receivedTimeRange: {
      type: String,
      default: ''
    },
    isPremium: {
      type: Boolean,
      default: true
    },
    forStudentId: {
      type: [Number, String],
      default: null
    }
  },

  watch: {
    receivedTimeRange(timeRange) {
      if (!this.isPremium) return;
      this.loadStudyTime(timeRange);
    },
    isPremium(newValue) {
      if (newValue && this.receivedTimeRange) {
        this.loading = true;
        this.loadStudyTime(this.receivedTimeRange);
      }
    },
    forStudentId() {
      if (this.isPremium && this.receivedTimeRange) {
        this.loading = true;
        this.loadStudyTime(this.receivedTimeRange);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }
    
    this.loadStudyTime(this.receivedTimeRange);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async loadStudyTime(timeRange) {
      if (timeRange === '' || !this.isPremium) {
        return;
      }

      this.studyTime = await getStudyTimeKpi(timeRange, this.forStudentId);
      this.loading = false; // Ocultar skeleton inmediatamente después de cargar
    }
  },

  computed: {
    studyTimeHours() {
      // studyTime.totalMinutes = 930
      // 930 / 60 = 15.5 -> Math.floor = 15
      return Math.floor(this.studyTime.totalMinutes / 60);
    },
    studyTimeMinutes() {
      // 930 % 60 = 30
      return this.studyTime.totalMinutes % 60;
    }
  }
}
</script>
